module.exports = __webpack_public_path__ + "img/供需资源优化.09855538.png";